import React from 'react';

const GlobalContext = React.createContext({
  showModal: false,
  contactModal: false,
  setModal: () => { }
});

export default GlobalContext;